module.exports = __webpack_public_path__ + "media/images/en/success-be9a90d5f4bdbebecd60c556e248289f.png";